import React from "react";
import { Link } from "components/common";
import useInputProfile from "../../hooks/useInputProfile";
import ForwarderRoutes from "../../Routes";
const InputProfileCell = ({ profileId }) => {
  const { data: profile, isFetching } = useInputProfile(profileId);
  if (isFetching && !profile) {
    return /* @__PURE__ */ React.createElement("span", null, profileId);
  }
  return /* @__PURE__ */ React.createElement(Link, { to: ForwarderRoutes.PROFILE.details(profileId) }, (profile == null ? void 0 : profile.title) || profileId);
};
export default InputProfileCell;
